import { render } from "./ContractTemplatesPage.vue?vue&type=template&id=1ae21019&scoped=true"
import script from "./ContractTemplatesPage.vue?vue&type=script&lang=js"
export * from "./ContractTemplatesPage.vue?vue&type=script&lang=js"

import "./ContractTemplatesPage.vue?vue&type=style&index=0&id=1ae21019&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae21019"]])

export default __exports__